import axios from "axios";

const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export default api;

export const handleApiError = (error: any) => {
  if (error.data?.error) {
    return error.data?.error;
  }
  if (error.data?.message) {
    return error.data?.message;
  }
};
